// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"66":"6fa08247bfb69b6e","92":"c09ce3f1e840872a","95":"482718ee67765ba2","253":"f83eb35880c8fe51","315":"50cbc43010c4176a","718":"6ab41f198bc285b6","819":"7921b0e947397574"}[chunkId] + ".js";
};